var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTreasureClosedMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-treasure-closed-marker",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 468.435,
    height: 324.091,
    viewBox: "0 0 468.435 324.091",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 468.435,
    height: 324.091,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 468.435,
    height: 98.278,
    transform: "translate(0 225.813)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M468.435,274.952c0,27.139-104.863,49.139-234.217,49.139S0,302.091,0,274.952s104.863-49.139,234.218-49.139,234.217,22,234.217,49.139"
  })))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 260.496,
    height: 32.578,
    transform: "translate(104.77 87.32)",
    fill: "#c99a81"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 260.496,
    height: 44.634,
    transform: "translate(104.77 130.01)",
    fill: "#a86e54"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 260.496,
    height: 44.634,
    transform: "translate(104.77 183.566)",
    fill: "#d3744f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 260.496,
    height: 44.634,
    transform: "translate(104.77 234.741)",
    fill: "#c99a81"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M60.669,82l39.164,1.684,11.9,175.957S113.418,272.264,125.2,279s-49.618,7.221-53.881-28.624S60.669,82,60.669,82",
    fill: "#ffdb43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M246.247,204.553H222.161a27.235,27.235,0,0,1-27.235-27.235V83.426h78.556v93.892a27.236,27.236,0,0,1-27.235,27.235",
    fill: "#ffdb43"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 260.496,
    height: 32.578,
    transform: "translate(104.77 8.132)",
    fill: "#c99a81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M407.089,82l-39.164,1.684-11.9,175.957S354.34,272.264,342.554,279s49.618,7.221,53.881-28.624S407.089,82,407.089,82",
    fill: "#ffdb43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M104.533,76.176H64.359S65.2,13.034,118.24,11.35c0,0-21.889,39.569-13.707,64.826",
    fill: "#ffdb43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M363.7,76.176H403.87s-.842-63.142-53.881-64.826c0,0,21.889,39.569,13.707,64.826",
    fill: "#ffdb43"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 260.496,
    height: 32.578,
    transform: "translate(104.77 45.026)",
    fill: "#9b8475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M366.888,281.653H101.214A29.109,29.109,0,0,1,72.1,252.544L60.2,81.293H407.9L396,252.544A29.109,29.109,0,0,1,366.888,281.653Z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M401.1,80.321H67.8a7.2,7.2,0,0,1-7.2-7.2V61.491A53.991,53.991,0,0,1,114.6,7.5H354.309A53.991,53.991,0,0,1,408.3,61.491V73.125A7.2,7.2,0,0,1,401.1,80.321Z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M134.381,7.5s-29.849,22.115-29.849,70.105",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M335.417,7.5s29.849,22.115,29.849,70.105",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M199.9,71.967a32.834,32.834,0,1,1,65.668,0",
    fill: "#ffdb43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M188.778,84.394v76.034a45.273,45.273,0,1,0,90.546,0V86.205",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M250.577,127.629a16.8,16.8,0,1,1-16.8-16.8A16.8,16.8,0,0,1,250.577,127.629Z",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    y2: 25.077,
    transform: "translate(233.777 144.43)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M200.95,79.43V66.906a33.049,33.049,0,0,1,66.1,0V79.43",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    x2: 76.212,
    transform: "translate(107.697 125.774)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    x2: 69.071,
    transform: "translate(289.146 125.774)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    x2: 79.782,
    transform: "translate(111.267 178.813)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    x2: 73.831,
    transform: "translate(282.005 178.813)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    x2: 237.979,
    transform: "translate(115.331 234.379)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    x2: 87.558,
    transform: "translate(116.556 45.868)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    x2: 87.558,
    transform: "translate(263.047 45.868)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M103,82.14l11.9,165.012s0,25.257,27.783,33.676",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M368,82.14,356.1,247.152s0,25.257-27.783,33.676",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 15
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTreasureClosedMarker);
export default __webpack_public_path__ + "static/media/icon-treasure-closed-marker.5fc4ec512aa4ce3008aaba7d6ae221d3.svg";
export { ForwardRef as ReactComponent };